import React, { useState } from 'react'
import { ApiError } from '@src/types/api'
import { Alert, AlertProps, AlertTitle, IconButton, styled, Typography } from '@mui/material'
import { FetchBaseQueryError } from '@reduxjs/toolkit/query'
import { SerializedError } from '@reduxjs/toolkit'
import { Close } from '@mui/icons-material'

type FetchError = {
  error: string
};

type AbortError = {
  name: 'AbortError'
};

export type ErrorAlertProps = Omit<AlertProps, 'children'> & {
  error: ApiError | FetchBaseQueryError | SerializedError | FetchError | Error;
  title?: string;
  closable?: boolean;
}

const ErrorAlert = styled(({ error: e, title, closable, ...props }: ErrorAlertProps) => {
  const [ error, setError ] = useState<ErrorAlertProps['error'] | null>(e)

  if(!error || (error as AbortError)?.name === 'AbortError') {
    return <></>
  }

  const message = (error as ApiError)?.data?.message
    || (error as Error)?.message
    || (error as FetchError)?.error

  return (
    <Alert {...props} severity="error" action={
      closable && (
        <IconButton size='small' onClick={() => setError(null)}>
          <Close fontSize='small' />
        </IconButton>
      )
    }>
      {title && <AlertTitle>{title}</AlertTitle>}
      {Array.isArray(message) ? message.map((m, i) => (
        <Typography key={i}>
          {m}
        </Typography>
      )) : (
        typeof message === 'string' ? message : (
          <pre>{JSON.stringify(error, null, 2)}</pre>
        )
      )}
    </Alert>
  )
})(({ theme: { spacing }}) => ({
  marginBottom: spacing(1.25)
}))

export default ErrorAlert